// src/components/IncomeSourceSelector.js
import React from 'react';
import { CheckSquare, Square, ChevronDown, ChevronUp, HelpCircle } from 'react-feather';

const INCOME_OPTIONS = [
  { key: 'w2', label: 'W-2 Wages', description: 'Job income where taxes were withheld' },
  { key: 'scheduleC', label: 'Self-Employment', description: 'Freelance, Uber, Side Gig (Schedule C)' },
  { key: 'scheduleE', label: 'Rentals & K-1s', description: 'Real Estate, Partnerships, S-Corps (Schedule E)' },
  { key: 'scheduleB', label: 'Interest & Dividends', description: 'Bank interest, Stocks, Investments (Schedule B)' },
  { key: 'schedule1', label: 'Other Income', description: 'Unemployment, Gambling, Prizes, Jury Duty' },
  { key: 'household', label: 'Household Wages', description: 'Nanny or Housekeeper income' },
  { key: 'tips', label: 'Unreported Tips', description: 'Cash tips not on W-2' },
  { key: 'waiver', label: 'Medicaid Waiver', description: 'Difficulty-of-care payments' },
  { key: 'combat', label: 'Combat Pay', description: 'Nontaxable military pay' },
  { key: 'form8919', label: 'Uncollected Tax', description: 'Form 8919 (Misclassified Employee)' },
];

function IncomeSourceSelector({ visibility, onToggle, formData, onDataChange }) {
  const [isOpen, setIsOpen] = React.useState(true);

  return (
    <>

      {/* --- INCOME SELECTOR --- */}
      <div className="dependent-card" style={{ marginBottom: '2rem', border: '2px solid var(--accent-primary)' }}>
        <div 
          className="content-box-header" 
          style={{ marginBottom: isOpen ? '1rem' : '0', cursor: 'pointer', borderBottom: isOpen ? '1px solid #f0e9e2ff' : 'none', paddingBottom: isOpen ? '1rem' : '0' }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <h3 style={{ fontSize: '1.2rem', margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--text-primary)' }}>
            {isOpen ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
            What kind of income did you have this year?
          </h3>
        </div>

        {isOpen && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem' }}>
            {INCOME_OPTIONS.map((option) => {
              const isChecked = visibility[option.key];
              return (
                <div 
                  key={option.key}
                  onClick={() => onToggle(option.key, !isChecked)}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '0.75rem',
                    padding: '0.75rem',
                    borderRadius: '0.5rem',
                    border: isChecked ? '1px solid var(--accent-primary)' : '1px solid var(--border-color)',
                    backgroundColor: isChecked ? '#fff7ed' : '#ffffff',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <div style={{ marginTop: '2px', color: isChecked ? 'var(--accent-primary)' : '#e1d2cbff' }}>
                    {isChecked ? <CheckSquare size={20} /> : <Square size={20} />}
                  </div>
                  <div>
                    <div style={{ fontWeight: '600', color: isChecked ? '#9a3412' : 'var(--text-primary)' }}>
                      {option.label}
                    </div>
                    <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: '1.3' }}>
                      {option.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}

export default IncomeSourceSelector;